export type AuthFlowConfig = {
  isEmailPassLoginShow: boolean;
  isEmailPassRegisterShow: boolean;
  isPhoneRequired: boolean;
};

export const AUTH_FLOW_DEFAULTS: AuthFlowConfig = {
  isEmailPassLoginShow: true,
  isEmailPassRegisterShow: true,
  isPhoneRequired: false,
};

export const parseAuthFlowConfig = (rawValue: unknown): AuthFlowConfig => {
  const fallback = { ...AUTH_FLOW_DEFAULTS };
  const source = String(rawValue ?? "").trim();
  if (!source) return fallback;

  try {
    const parsed = JSON.parse(source) as Record<string, unknown> | unknown[];
    if (!parsed || Array.isArray(parsed) || typeof parsed !== "object") {
      return fallback;
    }

    return {
      isEmailPassLoginShow:
        parsed.isEmailPassLoginShow === undefined
          ? fallback.isEmailPassLoginShow
          : Boolean(parsed.isEmailPassLoginShow),
      isEmailPassRegisterShow:
        parsed.isEmailPassRegisterShow === undefined
          ? fallback.isEmailPassRegisterShow
          : Boolean(parsed.isEmailPassRegisterShow),
      isPhoneRequired:
        parsed.isPhoneRequired === undefined
          ? fallback.isPhoneRequired
          : Boolean(parsed.isPhoneRequired),
    };
  } catch {
    return fallback;
  }
};
